import { useEffect } from "react";
import { Toaster } from "sonner";
import { ExcelDataProvider } from "../context/ExcelDataContext";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { LoginPage } from "./views/auth/LoginPage";
import { auth, handleAuthExpired } from "./views/auth/auth";
import { AppShell } from "./views/AppShell";
import { ProtectedRoute } from "./ProtectedRoute";
import { WelcomeScreen } from "./views/welcome/WelcomeScreen";
import { ObjectivesScreen } from "./views/welcome/ObjectivesScreen";
// @ts-ignore: allow side-effect CSS import (add a '*.css' declaration file if you want stricter typing)
import "./spendiq.css";

const SESSION_KEEPALIVE_INTERVAL_MS = 5 * 60 * 1000;

function AuthSessionKeepAlive() {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/login") return;

    let cancelled = false;
    const refreshSession = async () => {
      if (document.hidden) return;

      const authenticated = await auth.isAuthenticated();

      if (!cancelled && !authenticated) {
        handleAuthExpired();
      }
    };

    const handleVisibilityChange = () => {
      void refreshSession();
    };

    window.addEventListener("focus", handleVisibilityChange);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    void refreshSession();
    const intervalId = window.setInterval(refreshSession, SESSION_KEEPALIVE_INTERVAL_MS);

    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
      window.removeEventListener("focus", handleVisibilityChange);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [location.pathname]);

  return null;
}

function WelcomeRoute() {
  const navigate = useNavigate();

  return (
    <WelcomeScreen
      onGetStarted={() => {
        navigate("/project-navigation");
      }}
      onExplore={() => {
        navigate("/dashboard/empty");
      }}
    />
  );
}

function ObjectivesRoute() {
  const navigate = useNavigate();

  return (
    <ObjectivesScreen
      onContinue={(route) => {
        navigate(route);
      }}
    />
  );
}

export default function App() {
  return (
    <>
      <Toaster
      position="top-right"
      toastOptions={{
        style: {
          fontFamily:
            "Inter, system-ui, sans-serif",
          fontSize: 13,
        },
      }}
      />

      <BrowserRouter>
      <AuthSessionKeepAlive />
      <Routes>
        <Route
          path="/login"
          element={
            <LoginPage onLogin={() => {}} />
          }
        />

        <Route
          path="/welcome"
          element={
            <ProtectedRoute>
              <WelcomeRoute />
            </ProtectedRoute>
          }
        />

        <Route
          path="/project-navigation"
          element={
            <ProtectedRoute>
              <ObjectivesRoute />
            </ProtectedRoute>
          }
        />

        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <ExcelDataProvider>
                <AppShell
                  initialView="dashboard-empty"
                />
              </ExcelDataProvider>
            </ProtectedRoute>
          }
        />

        <Route
          path="*"
          element={
            <Navigate
              to="/dashboard/empty"
              replace
            />
          }
        />
        </Routes>
      </BrowserRouter>
    </>
  );
}